"use strict";

exports.__esModule = true;
var _ElementEditorHorizontalToolbar = require("./ElementEditorHorizontalToolbar");
Object.keys(_ElementEditorHorizontalToolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementEditorHorizontalToolbar[key]) return;
  exports[key] = _ElementEditorHorizontalToolbar[key];
});